import { Reducer } from 'redux';
import { SignatureState, SignatureTypes } from './types';

const INITIAL_STATE: SignatureState = {
  isLoading: true,
  hasError: false,
  data: [],
  total: 0,
};

const reducer: Reducer<SignatureState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SignatureTypes.LOAD_SIGNATURE_LIST_REQUEST:
      return {
        isLoading: true,
        hasError: false,
        data: [],
        total: 0,
      };
    case SignatureTypes.LOAD_SIGNATURE_LIST_SUCCESS:
      return {
        isLoading: false,
        hasError: false,
        data: action.payload.data,
        total: action.payload.total,
      };
    case SignatureTypes.LOAD_SIGNATURE_LIST_FAILURE:
      return {
        isLoading: false,
        hasError: true,
        data: [],
        total: 0,
      };
    default:
      return state;
  }
};

export default reducer;
